<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.changePhotosType' | translate}}
    <span *ngIf="selectedPhotos?.length > 0">{{' - '}} {{'claims-center.claimDocumentation.selectedPhotosForMoveCounter' |
        translate}} : {{selectedPhotos?.length}} </span>
</kendo-dialog-titlebar>

<form [formGroup]="targetSectionForm">
    <div fxLayoutGap="10px">
        <static-dictionary-select-ctrl [caption]="'claims-center.claimDocumentation.selectTargetPhotoType'"
            [formControlName]="'targetDocumentTypeId'" [staticDictionaryName]="'documentType'"
            [allowedValuesLimitation]="allowedDocumentTypes"
            [orderById]="true" [settings]="{fxFill:true}"></static-dictionary-select-ctrl>
    </div>
</form>


<kendo-dialog-actions>
    <button kendoButton (click)="changePhotosType()" [primary]="true" type="button">
        <span>{{'global.confirm' | translate}}</span>
    </button>
    <button  type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
</kendo-dialog-actions> 
